import { gql } from '@src/lib/gql'

export const MARK_ADVISOR_AGREEMENT_SIGNED = gql`
  mutation MarkAdvisorAgreementSigned($input: MarkAdvisorAgreementSignedInput!) {
    markAdvisorAgreementSigned(input: $input) {
      advisorAgreement {
        id
        advisorAgreementId
        statusKey
        signedAt
        signedStoredFileId
        status {
          id
          key
          title
        }
        signedFile {
          id
          storedFileId
          fullUrl
          title
        }
      }
    }
  }
`
